var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { Container } from "@/components/common/Container";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { PageTitle } from "@/components/common/PageTitle";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { TabsRequest } from "@/components/common/TabsRequest";
import { FormProvider } from "@/components/forms/FormContext";
import { ROUTES } from "@/routes/routes";
import { useState } from "react";
var TRIGGERS = [
    { name: "Número de CPF", value: "cpf" },
    { name: "Número de Registro", value: "registerNumber" },
];
export function Home() {
    var _a = useState("cpf"), selectedTab = _a[0], setSelectedTab = _a[1];
    var tabChange = function (value) {
        setSelectedTab(value);
    };
    var BREADCRUMB_ITEMS = [
        {
            name: "Página Inicial",
            path: "https://portal.pi.gov.br/detran/",
        },
        {
            name: "Solicitar PID",
            path: ROUTES.HOME,
            current: true,
        },
    ];
    return (_jsx(FormProvider, __assign({ selectedTab: selectedTab }, { children: _jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Permiss\u00E3o Internacional para Dirigir - PID" }), _jsxs(ServiceInfo, { children: [_jsx(ServiceInfoItem, { title: "Poder\u00E3o solicitar a Permiss\u00E3o Internacional para Dirigir:", content: [
                                "Possuírem CNH com data de validade com data maior que 6 meses da data de solicitação;",
                                "Possuírem prontuário no DETRAN-PI e residam no Piauí.",
                            ], listType: "unordered" }), _jsx(ServiceInfoItem, { title: "Instru\u00E7\u00F5es para a solicita\u00E7\u00E3o da PID:", content: [
                                'Preencha corretamente os dados abaixo, seguindo rigorosamente o que está impresso na CNH e confirme clicando em "Avançar";',
                                "Gere a taxa e em seguida efetue o pagamento na rede bancária ou via pix;",
                                "Acompanhe sua solicitação e verifique quando sua PID estará disponível para entrega;",
                            ], listType: "ordered" })] }), _jsx(TabsRequest, { triggers: TRIGGERS, tabChange: tabChange }), _jsx(EvaluateServiceButton, {})] }) })));
}
